<template>
  <v-app fill-height>
    <SystemBar />
    <AppBar />
    <v-main class="gradient-bg">
      <v-container fluid class="fill-height">
        <LoadingSpinner v-if="loading" class="mx-auto mb-auto" />
        <router-view v-if="!loading && !unauthorisedClient" />
      </v-container>
      <IdentificationSelector v-model="selectIdentity" />
      <UnauthorisedClient v-model="unauthorisedClient" />
    </v-main>
  </v-app>
</template>

<style type="scss">
html {
  overflow-y: auto;
}
.gradient-bg {
  background: linear-gradient(
    v-bind(settings?.colours.backgroundDir),
    v-bind(settings?.colours.background1) 0%,
    v-bind(settings?.colours.background1) 11%,
    v-bind(settings?.colours.background2) 100%
  );
}
.card-bg {
  background: linear-gradient(
    to bottom,
    v-bind(settings?.colours.card2) 0%,
    v-bind(settings?.colours.card) 100%
  );
}
.title-font {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}
.btn-primary {
  background: linear-gradient(
    90deg,
    v-bind(settings?.colours.primary),
    v-bind(settings?.colours.primary2)
  );
  color: white !important;
  border-radius: 10px !important;
  box-shadow: none;
}
.btn-error {
  background: linear-gradient(
    90deg,
    v-bind(settings?.colours.error),
    v-bind(settings?.colours.error2)
  );
  color: white !important;
  border-radius: 10px !important;
  box-shadow: none;
}
.btn-success {
  background: linear-gradient(
    90deg,
    v-bind(settings?.colours.success),
    v-bind(settings?.colours.success2)
  );
  color: white !important;
  border-radius: 10px !important;
  box-shadow: none;
}
.rounded-10 {
  border-radius: 10px !important;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex"
import AppBar from "@/components/App/AppBar"
import SystemBar from "@/components/App/SystemBar"
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue"
import UnauthorisedClient from "@/components/App/UnauthorisedClient.vue"
import IdentificationSelector from "@/components/App/IdentificationSelector.vue"
import { defaultColours } from "./utils"

export default {
  name: "App",

  data() {
    return {
      selectIdentity: false,
      loading: true,
      unauthorisedClient: false
    }
  },

  components: {
    AppBar,
    SystemBar,
    LoadingSpinner,
    UnauthorisedClient,
    IdentificationSelector
  },

  computed: {
    ...mapGetters(["settings", "identifications", "selectedIdentity"])
  },

  methods: {
    ...mapActions([
      "setSettings",
      "setIdentifications",
      "setSelectedIdentity",
      "setCountry"
    ]),

    redirectToID() {
      this.redirecting = true
      this.$cookies.set("tenantSlug", this.slug)
      window.location = "/authorize"
    }
  },

  async beforeMount() {
    try {
      await this.$axios.get("/oauth2/token/")
    } catch {
      window.location = `/oauth2/authorize/`
    }

    const identifications = await this.$axios.get("/oauth2/me/")
    this.setIdentifications(identifications.data)

    if (this.identifications.actors.length === 1) {
      this.setSelectedIdentity(this.identifications.actors[0].uid)
      this.setCountry(this.identifications.actors[0].payload.country)
    }

    if (this.identifications.actors.length === 0) this.unauthorisedClient = true

    if (this.identifications.actors.length > 1 && !this.selectedIdentity)
      this.selectIdentity = true

    this.setSettings({ colours: defaultColours })
    this.loading = false
  }
}
</script>
